import { render, staticRenderFns } from "./DWInstrumentNavigation.vue?vue&type=template&id=71dd0c59"
import script from "./DWInstrumentNavigation.vue?vue&type=script&lang=ts"
export * from "./DWInstrumentNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports